<template>
  <div class="wrapper">
    <menu-ver type="company" name="Company" />
    <div class="container m-3">
      <div class="table-header"></div>
      <h3>
        {{ $t(`mCompany.mylink.linkForms`) }}
      </h3>
      <ul class="list-group">
        <li class="list-group-item" v-for="item of fonts" :key="item.fuen_id">
          <span style="font-weight: bold; line-height: 30pt;">{{ item.fuen_nombre }}: </span>
          <span :id="item.fuen_nombre" @click="copyUrl(item.fuen_nombre)" style="cursor: pointer"
            >{{ servidor }}{{ id_emp }}/{{
              item.fuen_id
            }}</span
          >
          <button class="btn button buttonEdit" :style="{ backgroundColor: colorCompany }" @click="copyUrl(item.fuen_nombre)"><i class="fas fa-copy"></i></button>
        </li>
        <li class="list-group-item">
          <span style="font-weight: bold; line-height: 30pt;">{{ $t('mCompany.mylink.linkWhistleblower') }}: </span>
          <span id="linkWhistleblower" @click="copyUrl('linkWhistleblower')" style="cursor: pointer"
            >{{ servidor }}{{ id_emp }}/whistleblower/search</span>
          <button class="btn button buttonEdit" :style="{ backgroundColor: colorCompany }" @click="copyUrl('linkWhistleblower')"><i class="fas fa-copy"></i></button>
        </li>
      </ul>
      <h3 style="margin-top: 30pt">
        {{ $t(`mCompany.mylink.linkUser`) }}
      </h3>
      <ul class="list-group">
        <li class="list-group-item">
          <span style="line-height: 30pt; cursor: pointer" id="linkuser" @click="copyUrl('linkuser')">{{ servidor }}{{ id_emp }}/user/login</span>          
          <button class="btn button buttonEdit" :style="{ backgroundColor: colorCompany }" @click="copyUrl('linkuser')"><i class="fas fa-copy"></i></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import MenuVer from "../../../components/MenuVer";
import axios from "axios";

export default {
  data() {
    return {
      fonts: [
        {
          fuen_nombre: "APP",
          fuen_id: 0,
        },
      ],
    };
  },
  components: {
    MenuVer,
  },
  created() {
    this.changeBreadCrumb(12);
    this.bigDrop();
    this.getFonts();
  },
  computed: {
    ...mapState(["id_emp","colorCompany","servidor"]),
  },
  methods: {
    ...mapMutations(["changeBreadCrumb", "bigDrop"]),
    async getFonts() {
      try {
        const res = await axios.post(
          `${this.servidor}api/op.asp?tp=fuente&ac=listado`
        );
        if (res.data) {
          this.fonts = res.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    copyUrl(nombre) {
      const codigoACopiar = document.getElementById(nombre);
      let seleccion = document.createRange();
      seleccion.selectNodeContents(codigoACopiar);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(seleccion);
      document.execCommand("copy");
      window.getSelection().removeRange(seleccion);
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
}
</style>